.container {
    container-name: switch-target-header;
    container-type: inline-size;
}

.wrapper {
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;

    @container switch-target-header (max-width: 30rem) {
        & {
            flex-direction: column;
            flex-wrap: nowrap;
        }
    }
}

.description {
    flex: 1;
}
